import * as t from 'io-ts';
import { either } from 'fp-ts/lib/Either';
import moment from 'moment';

// The following regex is taken directly from moment.js source code for identifying valid ISO 8601 durations
const isoRegex =
// tslint:disable-next-line:max-line-length
/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

export const DurationDynamicType = new t.Type<moment.Duration, moment.Duration, unknown>(
    'Duration',
    (unknownObject): unknownObject is moment.Duration => moment.isDuration(unknownObject),
    (unknownObject, context) => either.chain(
        t.string.validate(unknownObject, context),
        s => {
            return isoRegex.test(s) ?
                t.success(moment.duration(s)) :
                t.failure(unknownObject, context);
        }),
    duration => duration
);

export type Duration = t.TypeOf<typeof DurationDynamicType>;
